import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./nav.css";
import Logo from "./duck1.png";

const Navbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState({});
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { name: "Home", path: "/" },
    {
      name: "Products",
      path: "/products",
    
    },
    { name: "Services", path: "/services" },
    { name: "About Us", path: "/about" },
    // { name: "Trend & News", path: "/news" },
  ];

  const toggleSubmenu = (index) => {
    setSubmenuOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleNavigate = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  return (
    <header className={`navbar-container ${scrolled ? "scrolled" : ""}`}>
      <nav className="navbar">
        {/* logo */}
        <div className="logo-container">
          <Link to="/" onClick={() => setSidebarOpen(false)}>
            <img src={Logo} alt="Logo" className="logo" />
          </Link>
        </div>

        {/*desktop */}
        <ul className="nav-links" data-aos="zoom-in">
          {navItems.map((item, idx) => (
            <li key={idx} className={item.submenu ? "has-dropdown" : ""}>
              <NavLink to={item.path} className={({ isActive }) =>
                    "nav-link" + (isActive ? " active custom-active fw-bold" : "")
                  }>{item.name}</NavLink>
              {item.submenu && (
                <ul className="dropdown">
                  {item.submenu.map((sub, i) => (
                    <li key={i}>
                      <NavLink to={sub.path}>{sub.name}</NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          <button style={{background:'rgba(123, 47, 0, 1)'}}
            className="btn btn-rounded me-2 text-white desktop-contact"
            onClick={() => handleNavigate("/contact")}
          >
            Contact Us
          </button>
        </ul>

        {/* mobile humour */}
        <div
          className={`hamburger ${sidebarOpen ? "active" : ""}`}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>

      {/* sidebar */}
      <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`}>
        <ul>
          {navItems.map((item, idx) => (
            <li key={idx}>
              <div
                className="mobile-item-header"
                onClick={() =>
                  item.submenu ? toggleSubmenu(idx) : handleNavigate(item.path)
                }
              >
                {item.name}
                {item.submenu && (
                  <span className={`arrow ${submenuOpen[idx] ? "open" : ""}`}>
                    ▼
                  </span>
                )}
              </div>
              {item.submenu && submenuOpen[idx] && (
                <ul className="mobile-submenu">
                  {item.submenu.map((sub, i) => (
                    <li key={i}>
                      <NavLink
                      className={({ isActive }) =>
                    "nav-link" + (isActive ? " active custom-active" : "")
                  }
                      to={sub.path} onClick={() => setSidebarOpen(false)}>
                        {sub.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          <button style={{background:'rgba(123, 47, 0, 1)'}}
            className="btn btn-rounded text-white mobile-contact"
            onClick={() => handleNavigate("/contact")}
          >
            Contact Us
          </button>
        </ul>
      </div>

      {/* Overlay */}
      {sidebarOpen && <div className="overlay" onClick={() => setSidebarOpen(false)}></div>}
    </header>
  );
};

export default Navbar;

